import React from 'react';
import cx from 'classnames';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Popover from 'react-bootstrap/lib/Popover';
import tooltipIcon from '/public/SiteIcons/tooltipIcon.svg';

const renderToolTip = (label, tooltipIconClass, tipPlacement = 'top') => {
    return (
        <>
            <OverlayTrigger placement={tipPlacement} overlay={<Popover id={`popover-positioned-${tipPlacement}`} className='imageUploadTooltipContainer'>{label}</Popover>}>
                <img src={tooltipIcon} className={cx(tooltipIconClass, 'svgImg')} />
            </OverlayTrigger>
        </>
    )
}

export default renderToolTip;